module.exports = __webpack_public_path__ + "media/images/repair-ab89d9bbc9803621d80f85b29d4da79c.png";